/** Đọc biến môi trường Vite (VITE_*) để tránh lỗi ambient context khi dùng trong file có declare global. */
export function getEnvVar(key: string): string {
    try {
        return (import.meta as unknown as { env?: Record<string, string | undefined> }).env?.[key] || '';
    } catch {
        return '';
    }
}
